<!--時間のヘッダー-->
<template lang="html">
  <div id="ruler" :style="getStyle">
    <div class="rulerTicksCell"
    v-for="(ticks, index) in $store.state.timeScaleTicks"
    :class="getTicksClass(index)"
    :style="ticksCellStyle">
      <span class="rulerTicks">{{ ticks }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ruler',
  data () {
    return {
      ticksCellStyle: {
        height: this.$store.state.rowHeight * this.$store.state.mobileHeightMagnification + 'px'
      }
    }
  },
  methods: {
    getTicksClass (index) {
      if (index === 0) {
        return 'tickTop'
      } else if (index % 2 === 0) {
        return 'ticksMain'
      } else {
        return 'ticksSub'
      }
    }
  },
  computed: {
    getStyle () {
      const style = {}
      style.width = this.$store.state.rulerWidth + 'px'

      if (this.$window.scrollX > 0 && this.$window.scrollY > 0) {
        style.position = 'absolute'
        style.top = this.$store.state.tbHeaderHeight +
                    this.$store.state.headerHeight + 2 + 'px'
        style.left = this.$window.scrollX + 2 + 'px'
        style['z-index'] = 1001
      } else if (this.$window.scrollX > 0) {
        style.position = 'absolute'
        style.left = this.$window.scrollX + 2 + 'px'
        style.top = this.$store.state.tbHeaderHeight +
                    this.$store.state.headerHeight + 3 + 'px'
        style['border-left'] = 'solid 2px black'
        style['z-index'] = 1001
      } else if (this.$window.scrollY > 0) {
        style.position = 'relative'
        style.top = this.$store.state.tbHeaderHeight + 'px'
        style['z-index'] = 1001
      } else {
        style['margin-top'] = '-1px'
      }
      return style
    }
  }
}
</script>

<style lang="css">
#ruler {
  box-sizing: border-box;
  border-right: solid 2px black;
}
.rulerTicksCell {
  box-sizing: border-box;
  background-color: white;

  text-align: right;
}
.tickTop {

}
.ticksMain {
  border-top-style: solid;
  border-top-width: 2px;
  border-top-color: black;
}
.ticksSub {
  border-top-style: dotted;
  border-top-width: 2px;
  border-top-color: #cccccc;

  font-size: 14px;
  color: #cccccc;
}
</style>



// WEBPACK FOOTER //
// SpRuler.vue?1192a8d7